import {reactive, ref} from "vue";

export class CustomTableService {
    static data = reactive(new Map());

    static init(data, loadData){
        const id = crypto.randomUUID();
        CustomTableService.data.set(id,  reactive({
            data: data,
            fields: {},
            currentSort: ref([]),
            currentFilters: ref([]),
            tableElements: {},
            loadData: loadData
        }));
        return id;
    }
}